import template from './name-and-year-commercial-autocomplete-no.jade';

export default angular
    .module('cian.addForm.nameAndYearCommercialAutocompleteNo', [])
    .directive('cianAfAboutBuildingNameAndYearCommercialAutocompleteNo', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {},
        controllerAs: 'nameAndYearCommercialAutocompleteNo',
        template,
    }))
    .name;
